import Vue from 'vue'
import Vuex from 'vuex'
import mutations from './mutations'
import getters from './getters'

Vue.use(Vuex)

const state = {
  houseInfo: {
    // room size
    roomW: 500,
    roomH: 350,
    roomD: 1000
  },
  graph: {
    // projector coordinates
    pjX: 250,
    pjY: 311,
    pjZ: 175,
    // screen size
    scrnW: 215,
    scrnH: 135.3,

    f_s2d: null,
    f_d2s: null,
    vLensShift: { max: 0, min: 0 },
    hLensShift: { max: 0, min: 0 },
    vhLensShift: null,
    // 单位
    unit: 'T_METRE_M'
  },
  vLensShiftNow: 0,
  hLensShiftNow: 0,
  temVLensShift: { max: 0, min: 0 },

  // 3d转化过之后的数据点
  drawData: null,
  blackDrawData: null,
  rangeDrawData: null,
  centerPointData: null,
  dashData: null,
  dashDataRemain: null,
  // 记录屏幕四个点的坐标（只与主墙相交，不与上下左右墙相交）
  screen4Point: null,

  aspectRatio: null,

  userInputModelName: null,
  searchMatchingModelData: null,
  searchSelectedModelData: null,
  searchMatchingLensID: null,
  searchSelectedLensData: null,

  bmMatchingModelData: null,
  bmSelectedModelData: null,
  bmMatchingLensID: null,
  bmSelectedLensData: null,

  htmMatchingModelData: null,
  htmSelectedModelData: null,
  htmMatchingLensID: null,
  htmSelectedLensData: null,

  matchingModelData: null,
  selectedModelData: null,
  matchingLensID: null,
  selectedLensData: null,
  cateValue: 0,

  cateRadio: 'bmRadio', // Bm:'bmRadio' Htm:'htmRadio'
  // 投影仪尺寸
  lenghProInit: 78.8,
  widthProInit: 50,
  lenghLSProInit: 78.8,
  widthLSProInit: 78,

  // 屏幕大小
  screenSize: 100,
  // 1.576
  // 页面比例
  proportion: 0,
  brightness: 200,
  vAngleFlag: false,
  vAngle: 0,
  hAngleFlag: false,
  hAngle: 0,
  offset: 0,
  floor2bottom: 0,

  // 英寸转化
  inchCom: 2.54,
  // 黑边处理时的长宽
  initScreenSize: {
    w: 215,
    h: 135.3
  },
  pjImgType: 0,

  // Not used
  dist: 0,
  pjHeight: 0,
  f_vOffset: null,
  frontSlider: 0,
  oldT: {
    x: 0,
    y: 0
  },
  gain: '1.0',
  application: '0',
  // 主视图Change the projector position字段
  projectorChecked: true,
  screenMoveChecked: false,
  // condition页面Throw distance的checkbox字段
  throwDistanceChecked: false,
  // condition页面Screen Size的checkbox字段
  screenSizeChecked: false,
  // condition页面Screen Size的checkbox字段选中时，表示的屏幕的坐标
  // condition页面Screen Size的checkbox字段
  realThrowDistanceChecked: false,
  floorFootProjectorChecked: false,
  // condition页面 Ceiling to ceiling mount bracket attachment point(天井から天吊り金具取付部まで) 的checkbox字段
  ceilingBottomProjectorChecked: false,
  // condition页面 Wall to wall mount bracket attachment point(壁から壁掛け金具取付部まで) 的checkbox字段
  wallWallProjectorChecked: false,
  pjXTip: 250,
  pjZTip: 175,
  blackSize: 0,
  centerPositionInit: null,
  projector_checked_side: true,
  projector_checked_top: true,
  // 表示点击Screen Position checkbox时，获取的屏幕左下角距下边的距离
  flToB: 0,
  flToL: 0,
  // 是否显示虚框
  dashFlag: false,
  // 语言
  language: 'en',
  languageChecked: false,
  searchTabActiveName: 'Search',
  // 判断屏幕是否接触frontView中的可移动区域
  isTouch: false,

  // 判断鼠标是否在frontView中，以触发键盘上下左右事件
  isInFrontView: false,

  position: 0,
  limitData: 0.001,
  selectRatioData: null,

  // view展示
  view: [{
    name: '3D View',
    value: 'right-down'
  }, {
    name: 'Side View',
    value: 'left-top'
  }, {
    name: 'Front View',
    value: 'right-top'
  }, {
    name: 'Top View',
    value: 'left-down'
  }],

  unitDataOptions: [{
    value: 'T_METRE_M',
    simplify: 'm'
  }, {
    value: 'T_MILLIMETER_MM',
    simplify: 'mm'
  }, {
    value: 'T_FEET_DECIMAL',
    simplify: 'ft'
  }, {
    value: 'T_FEET_FRACTION',
    simplify: 'ft'
  }, {
    value: 'T_INCH_DECIMAL',
    simplify: 'inch'
  }, {
    value: 'T_INCH_FRACTION',
    simplify: 'inch'
  }],
  isUSTWall: false,
  isSimple: false,
  USTPjTop: 0, // 以front view为基准,
  USTVDragFlag: false,
  USTLenshiftV: 0,
  fingerTouchStatus: false, // true:'on', false: 'off'
  plateTopToCeiling: 0,
  screenTopToCeiling: 0,
  plateBottomToScreen: 0,
  isLatvia: false,
  keyStoneVertical: 0,
  keyStoneHorizontal: 0,
  outOfSpecVal: false,
  isOutOfSpec: false,
  isVAngleOut: false,
  ustLensToFrontPj: 0, // lx
  searchParams: {},
  isFirstEnter: true,
  isConfigured: false,
  ratioScreenSizeMin: 0,
  ratioScreenSizeMax: 0
}

export default new Vuex.Store({
  state,
  mutations,
  getters
})
